<!--
 * @Author: lishiqiao
 * @Date: 2022-06-13 09:56:06
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-18 11:44:27
-->
<template>
  <div class="page-list">
    <!-- 搜索栏 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>养殖场&nbsp;:</label>
          <el-select v-model="params.params.baseId" filterable @change="selectBase">
            <el-option v-for="item in baseList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖区域&nbsp;:</label>
          <el-select v-model="params.params.groupId" filterable placeholder="请选择" @change="selectGropp">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in groupList" :key="item.id" :label="item.groupName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖单元&nbsp;:</label>
          <el-select v-model="params.params.boxId" filterable placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in boxList" :key="item.id" :label="item.boxCode" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>操作类型&nbsp;:</label>
          <el-select v-model="params.params.operationTypeList" multiple collapse-tags placeholder="请选择">
            <el-option v-for="item in operationTypeList" :key="item.id" :label="item.reviewType" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>投放时间&nbsp;:</label>
          <el-date-picker v-model="dateRange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            :picker-options="pickerOptions" @change="dateChange" type="daterange" range-separator="~"
            start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="page-search-item">
          <label>养殖品种&nbsp;:</label>
          <el-select v-model="params.params.breedId" filterable placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in breedList" :key="item.id" :label="item.breedName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>苗种类别&nbsp;:</label>
          <el-select v-model="params.params.seedCategoryId" filterable placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in seedlingTypeList" :key="item.id" :label="item.value" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>苗种名称&nbsp;:</label>
          <el-select v-model="params.params.seedId" filterable placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in seedlingInfoList" :key="item.seedId" :label="item.seedName" :value="item.seedId">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>供应商&nbsp;:</label>
          <el-select v-model="params.params.providerId" filterable placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in suppliersList" :key="item.id" :label="item.provider" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>记录状态&nbsp;:</label>
          <el-select v-model="params.params.reviewStatus" filterable placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in reviewStatusList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>汇总类型&nbsp;:</label>
          <el-select v-model="params.params.groupType" filterable placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in groupTypeList" :key="item.typeId" :label="item.typeName" :value="item.typeId">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="search">查询</div>
        <div class="reset-btn" @click="reset">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 分割线 -->
    <hr class="ufish-split-line" />
    <!-- 图表 -->
    <div v-show="showStatistical" class="charts-content">
      <div class="navigation_tags">
        <div class="label-type">
          <span v-bind:class="{ btn_selected: isNumberChart == '0' }" @click="toggleChartBtn('0')">投放数量统计</span>
          <span v-bind:class="{ btn_selected: isNumberChart == '1' }" @click="toggleChartBtn('1')">投放金额统计</span>
        </div>
        <div style="display: flex; justify-content: flex-end; align-items: center">
          <ul style="margin-right: 50px">
            <li>
              <span class="chart_text" v-for="(legend, i) in hintFodderData" :key="i"><span class="chart_icon"
                  v-bind:style="{ 'background-color': legend.color }"></span>{{ legend.shortName }}</span>
            </li>
          </ul>
          <div>
            <el-select class="chart-search-item" multiple collapse-tags placeholder="请选择饲料名称" v-model="showFodderData"
              @change="selectFodder()">
              <el-option v-for="item in allFodderData" :key="item.seedItemId" :label="item.shortName"
                :value="item.seedItemId">
                <span style="float: left; position: relative; padding-left: 15px"><i style="
                      position: absolute;
                      width: 6px;
                      height: 6px;
                      top: 14px;
                      left: 0px;
                      border-radius: 2px;
                    " v-bind:style="{ 'background-color': item.color }"></i>{{ item.shortName }}</span>
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="charts_info">
        <div style="height: 100%; width: 100%" id="fodder-charts"></div>
      </div>
    </div>
    <div style="
        display: flex;
        justify-content: center;
        padding: 15px;
        background: #fff;
      ">
      <p class="show-charts-btn" @click="showStatistical = !showStatistical">
        {{ showStatistical ? "收起统计折线图" : "展开统计折线图"
        }}<i v-bind:class="showStatistical
    ? 'iconfont icon-a-List-Expand'
    : 'iconfont icon-List-Collapse'
  "></i>
      </p>
    </div>
    <!-- 内容 -->
    <div class="page-list-content">
      <!-- 列表 -->
      <div class="page-list-title">
        <div><i class="title-icon"></i>投放记录</div>
        <div>单位 : {{ orgName }}</div>
        <div>
          日期 :
          {{ showStartDate }}-{{ showEndDate }}
        </div>
        <div class="page-list-btns">
          <el-dropdown style="margin-right: 20px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="switch-table" @click="download">模板下载</span>
          <FileUpload class="switch-table" :url="fileupload">导入报表</FileUpload>
          <span @click="exportTable">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <!-- 表格 -->
      <el-table :data="seedlingRecordsList" :max-height="tableHeight" border style="width: 100%"
        :row-class-name="tableRowClassName" @header-click="handleClick">
        <el-table-column prop="operationDate" :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          label="日期">
          <template slot-scope="scope">
            {{
              scope.row.operationDate
              ? scope.row.operationDate.slice(0, 10)
              : ""
            }}
          </template>
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="baseData" label="基地"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="groupName" label="区域分组"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="box" label="养殖单元"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[4].fixed" :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''"
          prop="square" label="塘口面积">
          <template slot-scope="scope">
            {{ scope.row.square }}{{ scope.row.squareUnitName }}
          </template></el-table-column>
        <el-table-column :fixed="fixedColumnList[5].fixed" :class-name="fixedColumnList[5].selected ? 'cellSelected' : ''"
          prop="yearPeriod" label="生产造次"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[6].fixed" :class-name="fixedColumnList[6].selected ? 'cellSelected' : ''"
          prop="bugNumber" label="放苗批次"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[7].fixed" :class-name="fixedColumnList[7].selected ? 'cellSelected' : ''"
          prop="operationTypeName" label="操作类型">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[8].fixed" :class-name="fixedColumnList[8].selected ? 'cellSelected' : ''"
          prop="batchNumber" label="养殖批次"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[9].fixed" :class-name="fixedColumnList[9].selected ? 'cellSelected' : ''"
          prop="breedingStage" label="养殖阶段">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[10].fixed"
          :class-name="fixedColumnList[10].selected ? 'cellSelected' : ''" prop="breedName" label="养殖品种">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[11].fixed"
          :class-name="fixedColumnList[11].selected ? 'cellSelected' : ''" prop="seedCategoryName" label="苗种类别">
        </el-table-column>
        <el-table-column prop="provider" label="供应商"> </el-table-column>
        <el-table-column label="转出/入单元">
          <template slot-scope="scope">
            <template v-if="scope.row.transferGroupName && scope.row.transferBox">
              {{
                scope.row.transferGroupName + "-" + scope.row.transferBox
              }}</template></template></el-table-column>
        <el-table-column label="规格(体长)">
          <template slot-scope="scope">
            {{ scope.row.specification }}
            <template v-if="scope.row.specificationUnitName &&
              scope.row.operationTypeName != '分苗'
              ">
              ({{ scope.row.specificationUnitName }})
            </template>
            <template v-if="scope.row.operationTypeName == '分苗'">
              (尾\斤)
            </template>
          </template>
        </el-table-column>
        <el-table-column label="规格(体重)"><template slot-scope="scope">
            {{ scope.row.totalWeight }}
            <template v-if="scope.row.totalWeight &&
              (scope.row.operationTypeName == '投苗' ||
                scope.row.operationTypeName == '补苗')
              ">
              (g)
            </template>
            <template v-if="scope.row.weightUnitName &&
              !(
                scope.row.operationTypeName == '投苗' ||
                scope.row.operationTypeName == '补苗'
              )
              ">
              ({{ scope.row.weightUnitName }})
            </template>
          </template>
        </el-table-column>
        <el-table-column label="实际数量">
          <template slot-scope="scope">
            {{ scope.row.putNumber
            }}{{
  scope.row.measureUnitName
  ? "(" + scope.row.measureUnitName + ")"
  : ""
}}
          </template></el-table-column>
        <el-table-column label="采购数量">
          <template slot-scope="scope">
            {{ scope.row.purchaseNum
            }}{{
  scope.row.quantityUnitName
  ? "(" + scope.row.quantityUnitName + ")"
  : ""
}}
          </template></el-table-column>
        <el-table-column label="单价">
          <template slot-scope="scope">
            {{ scope.row.unitPrice }}{{ scope.row.seedUnitPriceName }}
          </template></el-table-column>
        <el-table-column prop="totalAmount" label="金额"> </el-table-column>
        <el-table-column prop="reviewStatusName" label="记录状态">
        </el-table-column>
        <el-table-column prop="remarks" label="备注"> </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="uyu-pagination">
        <MyPagination @change="handleCurrentChange($event)" @changeSizes="handleSizeChange($event)"
          :sizes="[13, 26, 39, 50, 100, 200]" :pageNo.sync="params.currPage" :pageSize.sync="params.pageSize"
          :totalCount="totalCount">
        </MyPagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getBaseListsByUser,
  queryBaseGroupList,
  listDataPermissionBoxData,
  getOperationTypeList,
  getBreedList,
  getOrgInfoByOrgId,
  getSeedlingType,
  getListSeedlingInfo,
  getSuppliers,
  getTotalType,
  getListByPages,
  downloadTemplate,
  fileupload,
  getSeedlingRecordExportUrl,
  getOptionsData,
} from "./ym-seedling-records-service";
import FileUpload from "@/components/pc/file-upload.vue";
import MyPagination from "@/components/pc/my-pagination.vue";
import Page from "@/utils/methods/page";
import debounce from "../../../../../utils/debounce";
import * as $echarts from "echarts";
export default {
  name: "ym-seedling-records",
  data() {
    return {
      seedlingRecordsList: [],
      isNumberChart: "0", // echart展示模块
      boxList: [], // 养殖单元列表
      baseList: [], // 养殖场列表
      groupList: [], // 养殖区域列表
      operationTypeList: [], // 操作类型列表
      breedList: [], // 养殖品种列表
      seedlingTypeList: [], // 苗种类别列表
      seedlingInfoList: [], // 苗种名称列表
      suppliersList: [], // 供应商列表
      reviewStatusList: [
        {
          id: 0,
          name: "草稿",
        },
        {
          id: 1,
          name: "待审核",
        },
        {
          id: 2,
          name: "已审核",
        },
      ], // 记录状态
      groupTypeList: [], // 汇总类型
      total: "合计",
      fileupload: "",
      dateRange: [],
      PageDisplay: true,
      orgName: "", // 单位名称
      showStartDate: "", // 显示的开始日期
      showEndDate: "", // 显示的结束日期
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "operationDate",
          fixed: false,
          selected: false
        },
        {
          prop: "baseData",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "box",
          fixed: false,
          selected: false
        },
        {
          prop: "square",
          fixed: false,
          selected: false
        },
        {
          prop: "yearPeriod",
          fixed: false,
          selected: false
        },
        {
          prop: "bugNumber",
          fixed: false,
          selected: false
        },
        {
          prop: "operationTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "batchNumber",
          fixed: false,
          selected: false
        },
        {
          prop: "breedingStage",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
        {
          prop: "seedCategoryName",
          fixed: false,
          selected: false
        },
      ],
      // 分页参数
      params: {
        currPage: 1,
        pageSize: 13,
        orderBy: "desc",
        orderByName: "groupName",
        params: {
          orgId: "", // 机构ID
          baseId: "", // 基地ID
          groupId: "", // 区域ID
          boxId: "", // 塘口ID
          operationType: "", // 操作类型
          operationTypeList: [],
          breedId: "", // 养殖品种ID
          startTime: "", // 开始时间
          endTime: "", // 结束时间
          periodId: "", // 养殖造次
          providerId: "", // 供应商ID
          seedId: "", // 苗种ID
          seedCategoryId: "", // 苗种类别，根据字典类型获取
          type: "0", // 0 数量, 1 金额
          reviewStatus: "", // 审核状态，0:草稿，1：待审核，2：已审核
          groupType: "",
        },
      },
      totalCount: 0, // 总条数
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
      exportParams: {}, // 导出参数
      typeColors: [
        "#5574FA",
        "#F553FB",
        "#4EDDB6",
        "#2BCCFA",
        "#AE53FB",
        "#4297FF",
        "#98DD4E",
        "#FAA02B",
        "#FF427C",
        "#DCD400",
        "#7CD82A",
        "#FBDC09",
        "#97A9F7",
        "#FB92FF",
        "#84EFD2",
        "#8CE5FE",
        "#C78BFB",
        "#7DB6FC",
        "#B0E874",
        "#F8BE72",
        "#F79BB7",
        "#EBE535",
        "#ADEA76",
        "#FFE84B",
      ], // 折线图品种类型颜色
      isNumberChart: "0", // 是否数量图表 0 | 1 |
      showStatistical: false, // 是否展示统计折线图
      showFodderData: [], // 显示的饲料信息列表
      allFodderData: [], // 所有的饲料信息列表
      hintFodderData: [], // 提示的饲料信息列表
      barInstance: null, // echart 图渲染对象
      animationDuration: 6000,
    };
  },
  components: { MyPagination, FileUpload },
  created() {
    this.tableHeight = window.innerHeight - 500;
    this.initTime();
    this.getPageList(this.params);
    this.getBaseListsByUser(); // 获取基地列表
    this.getOperationTypes(); // 获取操作类型列表
    this.getSeedlingType(); // 获取苗种类别列表
    this.params.params.orgId = localStorage.getItem("orgId");
    this.orgName = localStorage.getItem("orgName");
    this.fileupload = fileupload(); // echart自适应
    // debounce函数让一个方法在一定时间内只能执行一次
    this.resizeHandler = debounce(
      () => {
        this.barInstance && this.barInstance.resize();
      },
      100,
      false
    );
    // 监听浏览器窗口页面
    window.addEventListener("resize", this.resizeHandler);
  },
  mounted() {
    Page.pagesTableFixed(); // 表头固定
  },
  methods: {
    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 10:17:42
     * @description: 获取用户权限基地
     */
    getBaseListsByUser() {
      getBaseListsByUser().then((res) => {
        if (res.code == "0000") {
          this.baseList = res.data;
          if (this.baseList && this.baseList.length) {
            this.params.params.orgId = this.baseList[0].orgId;
            this.params.params.baseId = this.baseList[0].id;
            this.queryBaseGroupList(this.params.params.baseId);
            this.getListSeedlingInfo(this.params.params.orgId); // 获取苗种名称接口
            this.getParentByOrgId(this.params.params.orgId); // 获取机构后获取养殖品种
            this.getSuppliersList(this.params.params.orgId); // 供应商
            this.getTotalType(); // 汇总类型
            this.isNumberChart = "0";
            this.params.params.type = "0";
            this.getEchartsData(this.params); // 获取柱状图数据
            this.params.params.boxId = "";
            this.boxList = [];
          }
        }
      });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 10:58:42
     * @description: 选择基地
     * @param {*} event
     */
    selectBase(event) {
      if (!event) {
        return;
      }
      this.params.params.groupId = "";
      this.groupList = [];
      this.params.params.boxId = "";
      this.boxList = [];
      this.params.params.breedId = "";
      this.breedList = [];
      this.params.params.seedId = "";
      this.seedlingInfoList = [];
      this.params.params.providerId = "";
      this.suppliersList = [];
      const orgId = this.baseList.filter((item) => item.id === event)[0].orgId;
      if (this.params.params.orgId !== orgId) {
        this.params.params.orgId = orgId;
        this.getListSeedlingInfo(this.params.params.orgId); // 获取苗种名称接口
        this.getParentByOrgId(this.params.params.orgId); // 获取机构后获取养殖品种
        this.getSuppliersList(this.params.params.orgId); // 供应商
      }
      this.queryBaseGroupList(event);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 10:55:27
     * @description: 获取权限下的区域
     * @param {*} baseId 基地id
     */
    queryBaseGroupList(baseId) {
      queryBaseGroupList(baseId).then((res) => {
        if (res.code === "0000") {
          this.groupList = res.data;
        }
      });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 11:04:26
     * @description: 选择区域
     * @param {*} event
     */
    selectGropp(event) {
      this.params.params.boxId = "";
      this.boxList = [];
      if (!event) {
        return;
      }
      this.listDataPermissionBoxData(event);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 11:02:13
     * @description: 获取塘口接口
     * @param {*} groupId 区域id
     */
    listDataPermissionBoxData(groupId) {
      listDataPermissionBoxData(groupId).then((res) => {
        if (res.code === "0000") {
          this.boxList = res.data;
        }
      });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 11:29:21
     * @description: 获取操作类型列表 3. 投苗、补苗、移箱、分苗、转出、转入
     */
    getOperationTypes() {
      getOperationTypeList(3).then((res) => {
        if (res.code === "0000") {
          this.operationTypeList = res.data;
        }
      });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 11:47:12
     * @description: 获取养殖品种下拉菜单列表
     * @param {*} orgId 机构id
     */
    getBreedList(orgId) {
      getBreedList(orgId).then((res) => {
        if (res.code === "0000") {
          this.breedList = res.data;
        }
      });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 11:49:19
     * @description: 根据当前机构id获取一级机构id
     * @param {*} orgId 当前机构id
     */
    getParentByOrgId(orgId) {
      getOrgInfoByOrgId(orgId).then((res) => {
        if (res.code === "0000") {
          const topParentId = res.data.id;
          this.getBreedList(topParentId);
        }
      });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 15:04:11
     * @description: 获取苗种类别接口
     */
    getSeedlingType() {
      getSeedlingType().then((res) => {
        if (res.code === "0000") {
          this.seedlingTypeList = res.data;
        }
      });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 15:10:42
     * @description: 获取苗种名称接口
     * @param {*} orgId 机构id
     */
    getListSeedlingInfo(orgId) {
      getListSeedlingInfo(orgId).then((res) => {
        if (res.code === "0000") {
          this.seedlingInfoList = res.data;
        }
      });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 15:16:25
     * @description: 根据机构id获取供应商列表
     * @param {*} orgId 机构id(放子机构id或一级机构都行, 后端已设置自动找到一级机构)
     */
    getSuppliersList(orgId) {
      getSuppliers(orgId).then((res) => {
        if (res.code === "0000") {
          this.suppliersList = res.data;
        }
      });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 15:23:18
     * @description: 获取汇总类型
     */
    getTotalType() {
      getTotalType().then((res) => {
        if (res.code === "0000") {
          this.groupTypeList = res.data;
        }
      });
    },
    // 选择月
    monthChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startTime = val[0];
      this.params.params.endTime = val[1];
    },
    // 选择日期
    dateChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startTime = val[0];
      this.params.params.endTime = val[1];
    },
    // 查询
    search() {
      this.getPageList(this.params);
      this.getEchartsData(this.params);
    },
    // 初始化时间
    initTime() {
      this.params.currPage = 1;
      this.params.pageSize = 13;
      this.params.params.year = null;
      this.params.params.startTime = null;
      this.params.params.endTime = null;
      this.dateRange = [];
      this.params.params.startTime = this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      this.params.params.endTime = this.$moment().format("YYYY-MM-DD");
      this.dateRange.push(this.params.params.startTime);
      this.dateRange.push(this.params.params.endTime);
    },
    // 重置
    reset() {
      this.params.params.groupId = "";
      this.params.params.boxId = "";
      this.boxList = [];
      this.params.params.operationType = "";
      this.params.params.operationTypeList = [];
      this.params.params.startTime = this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      this.params.params.endTime = this.$moment().format("YYYY-MM-DD");
      this.dateRange = [
        this.params.params.startTime,
        this.params.params.endTime,
      ];
      this.params.params.breedId = "";
      this.params.params.seedCategoryId = "";
      this.params.params.seedId = "";
      this.params.params.providerId = "";
      this.params.params.reviewStatus = "";
      this.params.params.groupType = "";
      this.initTime();
      this.getEchartsData(this.params);
      this.getPageList(this.params);
    },
    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.operationDate === "合计") {
        return "heji-row";
      }
    },
    // 显示的单位-年-月-日
    showListData() {
      this.showStartDate = this.$moment(this.params.params.startTime).format(
        "YYYY年MM月DD日"
      );
      this.showEndDate = this.$moment(this.params.params.endTime).format(
        "YYYY年MM月DD日"
      );
    },
    /**
     * 获取列表数据分页
     * @param params 条件参数
     */
    getPageList(params) {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getListByPages(params)
        .then((res) => {
          if (res.code === "0000") {
            this.params.currPage = res.data.pageNumber;
            this.params.pageSize = res.data.pageSize;
            this.totalCount = res.data.totalCount;
            this.seedlingRecordsList = res.data.list;
            if (res.data.pageNumber === 1) {
              this.seedlingRecordsList.unshift({
                baseData: "",
                totalAmount: res.data.totalResult.totalPutAmount,
                putNumber: res.data.totalResult.totalPutNumber,
                purchaseNum: res.data.totalResult.totalPurchaseNum,
                box: res.data.totalResult.totalBoxNumber,
                square: res.data.totalResult.totalSquare,
                operationDate: this.total,
              });
              // 导出的参数 解决选择了查询条件但没有点击查询时导出数据不一致的bug
              this.exportParams = JSON.parse(JSON.stringify(params));
            }
            this.showListData();
            loading.close();
          }
        })
        .catch((err) => {
          this.$message.error(err);
          loading.close();
        });
    },
    // 模板下载
    download() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        const params = {
          fileName: "投放信息模板导入",
        };
        Page.exportDatas(downloadTemplate(), params);
      });
    },
    // 导出
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        const params = {
          titleName: "投放记录列表",
          sheetName: "列表",
          fileName: "投放记录列表",
          // fileCode: "feedingRecordExport_zh",
          param: this.exportParams,
        };
        Page.exportDatas(getSeedlingRecordExportUrl(), params);
      });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 17:32:40
     * @description: 切换单前页
     * @param {*} event
     */
    handleCurrentChange(event) {
      this.params.currPage = event;
      this.getPageList(this.params);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-13 17:33:35
     * @description: 改变当前分页总数
     * @param {*} event
     */
    handleSizeChange(event) {
      this.params.pageSize = event;
      this.params.currPage = 1;
      this.getPageList(this.params);
    },

    // 数量、金额图表切换
    toggleChartBtn(flag) {
      this.isNumberChart = flag;
      this.params.params.type = flag;
      this.getEchartsData(this.params);
    },

    // 选择饲料
    selectFodder() {
      let showdata = [];
      this.hintFodderData =
        ((showdata = this.allFodderData.filter((re) =>
          this.showFodderData.includes(re.seedItemId)
        )),
          showdata.slice(0, 3));
      this.applyLine(showdata);
    },

    // 获取echarts数据
    getEchartsData(params) {
      getOptionsData(params).then((res) => {
        if (res.code === "0000") {
          this.allFodderData = res.data.map((item, index) => {
            item.color = this.typeColors[index] || "#999999";
            return item;
          });
          let arr = [];
          this.showFodderData = this.showFodderData =
            ((arr = this.allFodderData.slice(0, 3)),
              arr.map((re) => re.seedItemId));
          this.hintFodderData = arr;
          if (this.showStatistical) {
            this.applyLine(this.hintFodderData);
          }
        }
      });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-06-14 10:14:11
     * @description: 图表渲染
     * @param {*} echartsData
     */
    applyLine(echartsData) {
      this.barInstance && this.barInstance.clear();
      this.barInstance = new $echarts.init(
        document.getElementById("fodder-charts")
      );
      if (echartsData.length) {
        const option = {
          color: echartsData.map((item) => item.color),
          tooltip: {
            trigger: "axis",
            backgroundColor: "#ffffff",
            padding: 12,
            textStyle: {
              fontSize: "12px",
              lineHeight: "22px",
              color: "#333333",
            },
            extraCssText: "box-shadow: 0px 0px 7px 0px #E0E0E0;",
          },
          grid: {
            top: "3%",
            left: "5%",
            right: "2%",
            bottom: "25px",
          },
          xAxis: [
            {
              type: "category",
              // name: this.translate.instant('GLOBAL_CENTRE_DATA.RIQI'),
              name: "",
              data: echartsData[0].dataList.map((item) => item.time),
              axisLine: {
                lineStyle: {
                  type: "solid",
                  color: "#DEE4E6",
                },
              },
              nameTextStyle: {
                color: "#666666",
                fontFamily: "ArialMT",
                fontWeight: "400",
              },
              axisLabel: {
                color: "#666666",
                fontFamily: "ArialMT",
                fontWeight: "400",
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "",
              // minInterval: 200,      // 坐标最小划分单位，设置为1表示坐标轴节点保留整数
              splitNumber: 6, // 指定坐标轴节点分割数（非强制），会按照预算自行调整最合适的分割数
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                lineStyle: {
                  type: "dashed",
                  color: "#DEE4E6",
                },
              },
              nameTextStyle: {
                color: "#666666",
                fontFamily: "ArialMT",
                fontWeight: "400",
              },
              axisLabel: {
                color: "#666666",
                fontFamily: "ArialMT",
                fontWeight: "400",
              },
            },
          ],
          series: echartsData.map((item) => {
            return {
              name: item.shortName,
              type: "line",
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 1,
                    color: item.color,
                  },
                },
              },
              data: item.dataList.map((item2) => item2.num),
            };
          }),
        };
        this.barInstance.setOption(option, this.animationDuration);
      }
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  watch: {
    showStatistical(oldVal, newVal) {
      if (oldVal) {
        this.$nextTick(() => {
          this.applyLine(this.hintFodderData);
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.page-search-item {
  .el-date-editor {
    width: 202px;
    padding: 0 !important;

    .el-range__icon {
      width: 15px;
      font-size: 12px;
      margin-left: 5px;
    }

    .el-range-separator {
      padding: 0;
    }

    .el-range-input {
      font-size: 12px;
    }

    .el-range__close-icon {
      font-size: 12px;
      width: 10px;
      margin-left: -3px;
      line-height: 33px;
    }
  }
}

.navigation_tags {
  width: 100%;
  height: 83px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  >div:first-child {
    float: left;
    // margin-top: 24px;
    font-size: 14px;
    font-size: 14px;
    font-family: "MicrosoftYaHei";
    font-weight: 400;
    color: rgba(35, 38, 52, 1);

    >span {
      display: block;
      float: left;
      cursor: pointer;
      margin-right: 40px;

      &:not(:last-child) {
        position: relative;

        &::after {
          position: absolute;
          content: "";
          width: 1px;
          height: 12px;
          background-color: rgba(221, 221, 221, 1);
          top: 4px;
          right: -20px;
        }
      }
    }

    >span:last-child>button {
      float: left;
      border: none;
      outline: none;
      background-color: transparent;
      box-shadow: none;
      font-size: 14px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: #abadb3;
    }

    >span:last-child>button:hover {
      border-bottom: 1px solid #abadb3;
      height: 17px;
    }
  }

  .btn_selected {
    font-size: 14px !important;
    font-family: "MicrosoftYaHei" !important;
    font-weight: bold !important;
    color: #0232ff !important;

    &:hover {
      border-bottom: 1px solid #0232ff !important;
    }
  }

  .label-type {
    position: relative;
    padding-left: 10px;

    &::after {
      content: "";
      position: absolute;
      display: inline-block;
      width: 3px;
      height: 12px;
      background: #5574fa;
      margin-right: 10px;
      left: 0;
      top: 4px;
    }
  }
}

.chart-search-item {
  min-width: 260px;

  /deep/input {
    height: 34px !important;
    border-radius: 2px;
  }

  // 日期选择器字体图标居中
  /deep/.el-input {
    .el-input__icon {
      line-height: 34px;
    }
  }

  /deep/.el-input__inner {
    border: 1px solid #dcdfe6;
  }

  display: flex;
}

.show-charts-btn {
  cursor: pointer;
  font-size: 14px;
  color: #0232ff;

  i {
    font-size: 13px;
    display: inline-block;
    margin-left: 5px;
  }
}

.chart_text {
  font-family: "SimSun";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}

.chart_icon {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 2px;
  margin-right: 6px;
  margin-left: 30px;
}

.charts-content {
  background-color: #fff;
  padding: 0px 34px 38px 34px;
  height: 325px;

  .charts_info {
    background-color: transparent;
    height: 242px;
    width: 100%;
  }
}

.page-list .page-list-content {
  margin-top: 0px;
}

.ufish-split-line {
  margin: 0;
  padding: 0;
  border: 0;
  border-top: 1px solid #eee;
}
</style>